export class GsbRequestBase {
    variation;
}
export class GetTokenRequest extends GsbRequestBase {
    email;
    password;
    mfaToken;
    runMfaIfEnabled;
    remember;
    includeUserInfo;
}
export class VerifyTokenRequest extends GsbRequestBase {
}
export class GsbUploadFileRequest extends GsbRequestBase {
    file;
    entity;
}
export class GsbSaveRequest extends GsbRequestBase {
    entDefName;
    entDefId;
    entityDef;
    entity;
    filters;
    entityId;
}
export class GsbSaveMappedRequest extends GsbRequestBase {
    entDefName;
    entDefId;
    entityDef;
    items;
    entityId;
    propName;
    mapColName;
    propertyName;
}
export class GsbSaveMultiRequest extends GsbRequestBase {
    entDefName;
    entDefId;
    entityDef;
    entities;
}
export class GsbBulkCallRequest {
    endPoint;
    request;
    reqId;
}
export class GsbBulkRequest extends GsbRequestBase {
    bulkCalls;
}
export class GsbGetCodeRequest extends GsbRequestBase {
    codeGeneratorId = "";
}
export function isDefinitionSet(request) {
    if (typeof request !== "object" || request === null)
        return false;
    if ("entDefName" in request && request.entDefName)
        return true;
    if ("entDefId" in request && request.entDefId)
        return true;
    const entityDef = "entityDef" in request ? request.entityDef : undefined;
    if (typeof entityDef !== "object" || entityDef === null)
        return false;
    if ("name" in entityDef && entityDef.name)
        return true;
    if ("id" in entityDef && entityDef.id)
        return true;
    return false;
}
//# sourceMappingURL=requests.js.map